import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'react-bootstrap';
import GenericTable from 'componentes/generic/GenericTable.js';

const DelegacionesProfecoTable = ({
  delegacionesProfeco,
  setIdDelegacionProfecoEdit,
  setOpenModal
}) => {
  const columns = [
    {
      accessorKey: 'nombre',
      header: 'Nombre',
      headerProps: { style: { minWidth: '300px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'comentarios',
      header: 'Comentarios',
      headerProps: { style: { minWidth: '200px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' },
      cell: ({ row }) => {
        return (
          <div>
            {row.original.comentarios.length > 30
              ? row.original.comentarios.substring(0, 27) + '...'
              : row.original.comentarios}
          </div>
        );
      }
    },
    {
      accessorKey: 'municipio.descripcion',
      header: 'Municipio',
      headerProps: { style: { minWidth: '200px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'iddelegacion',
      header: '',
      disableSortBy: true,
      cellProps: {
        className: 'text-end'
      },
      cell: ({ row: { original } }) => {
        const { iddelegacion } = original;

        return (
          <>
            <Button
              variant="falcon-default"
              size="sm"
              title="Editar"
              onClick={() => {
                setIdDelegacionProfecoEdit(iddelegacion);
                setOpenModal(true);
              }}
            >
              <FontAwesomeIcon icon="pencil-alt" />
            </Button>
          </>
        );
      }
    }
  ];
  return (
    <>
      <GenericTable
        data={delegacionesProfeco}
        title="Delegaciones Profeco"
        columns={columns}
        addAction={() => {
          setIdDelegacionProfecoEdit(0);
          setOpenModal(true);
        }}
      ></GenericTable>
    </>
  );
};
DelegacionesProfecoTable.propTypes = {
  delegacionesProfeco: PropTypes.array.isRequired,
  setIdDelegacionProfecoEdit: PropTypes.func.isRequired,
  setOpenModal: PropTypes.func.isRequired
};
export default DelegacionesProfecoTable;
